import { useUserStore } from "@/stores/user";
import type { MiddlewareContext } from "@/types";

// Redirect to the sign page if trying to access protected page without authentication
export const requiresAuth = ({ to, next, router }: MiddlewareContext) => {
  const store = useUserStore();

  if (!store.isAuthenticated) {
    // Redirect to create account page if trying to add to cart
    if (to.name === "Cart" && to.query.sku && to.query.quantity) {
      router.push({ name: "CreateAccount", query: { redirect: to.fullPath.replace("?", "&") } });
      return;
    }

    router.push({
      path: "/signin",
      // Save the location we were at to come back later
      query: { redirect: to.fullPath.replace("?", "&") }
    });
    return;
  }

  return next();
};
